<template>
  <div v-if="paginationInf && paginationInf.totalPages > 1">
    <span v-if="showPrev">
      <v-btn
        small
        text
        @click="pageChange(1)"
      >
        1
      </v-btn>
      <v-btn
        text
        small
        v-if="showPrevDots"
      >...</v-btn>
    </span>
    <v-btn
      small
      text
      v-for="(page, key) in pages"
      :key="key"
      :disabled="page === paginationInf.currentPage"
      @click="pageChange(page)"
    >
      {{ page }}
    </v-btn>
    <span v-if="showNext">
      <v-btn
        text
        small
        v-if="showNextDots"
      >...</v-btn>
      <v-btn
        small
        text
        @click="pageChange(paginationInf.totalPages)"
      >
        {{ paginationInf.totalPages }}
      </v-btn>
    </span>
  </div>
</template>
<script>
export default {
  name: 'Pagination',
  props: {
    paginationInf: {
      required: false,
      type: Object,
      default () {
        return {
          currentPage: 1,
          totalPages: 1
        }
      }
    }
  },
  computed: {
    showPrevDots () {
      let res = false
      if (this.paginationInf.currentPage >= 4) {
        res = true
      }
      return res
    },
    showPrev () {
      let res = false
      if (this.paginationInf.currentPage >= 3 && this.paginationInf.totalPages > 4) {
        res = true
      }
      return res
    },
    pages () {
      let res = [...Array(this.paginationInf.totalPages + 1).keys()].splice(1)
      if (res.length > 4) {
        if (this.paginationInf.currentPage > 2 && this.paginationInf.currentPage < this.paginationInf.totalPages - 1) {
          res = res.slice(this.paginationInf.currentPage - 2, this.paginationInf.currentPage + 1)
        } else if (this.paginationInf.currentPage > this.paginationInf.totalPages - 4) {
          res = res.slice(-3)
        } else {
          res = res.slice(0, 3)
        }
      }
      return res
    },
    showNext () {
      let res = false
      if (this.paginationInf.currentPage <= this.paginationInf.totalPages - 2 && this.paginationInf.totalPages > 4) {
        res = true
      }
      return res
    },
    showNextDots () {
      let res = false
      if (this.paginationInf.currentPage <= this.paginationInf.totalPages - 3) {
        res = true
      }
      return res
    }
  },
  methods: {
    pageChange (page) {
      this.$emit('pageChange', page)
    }
  }
}
</script>
